import React from 'react';
import HeaderContainer from './header.styles';
import HeaderLinks from './../header-links/header-links.component';

const Header = () => {
    return (
        <HeaderContainer>
            <div className="container">
                <a href="#">
                    <img src="https://i.ibb.co/1KcQ7gw/logo.png" alt="logo" />
                </a>
                <HeaderLinks />
            </div>
        </HeaderContainer>
    );
};
export default Header;
